import AIAssistantPanel from './aiAssistantPanel';

export default AIAssistantPanel;
